import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CATEGORIES = [
  "U7", "U9", "U11", "U13", "U15", "U17", "U19", "U21",
  "Espoirs", "Amateur", "Semi-professionnel", "Professionnel",
  "Senior", "Vétérans", "Féminin", "Loisirs",
];

export const CategoriesAPI = {
  get: () => api.get("/categories").then((r) => r.data),
  update: (values) => api.put("/categories", { values }).then((r) => r.data),
};

export function useCategories() {
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  useEffect(() => {
    CategoriesAPI.get()
      .then((d) => {
        if (Array.isArray(d?.values) && d.values.length) setCategories(d.values);
      })
      .catch(() => {});
  }, []);
  return categories;
}
